import { format } from 'date-fns';
import { Pages } from 'modules/navigation/domain/enums/pages';
import { TeamCardHeaderRow } from 'modules/teams/ui/components/team-card/styles';
import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { AppDispatch } from 'store/store';
import { useModal } from 'ud-ui/components/modal-old/use-modal';
import UDButton from '../../../ud-ui/components/button';
import TeamLogo from '../../../ud-ui/components/team-logo';
import UDText from '../../../ud-ui/components/text';
import { Player, Team } from '../../domain/interfaces/player';
import { kickTournamentUserFromTeam } from '../../store/actions';

interface IProps {
  index: number;
  team: Team;
  player: Player;
}

function TeamCard(props: IProps) {
  const { team, index, player } = props;
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const { open, close, Modal } = useModal({ defaultShow: false });

  const handleClickTeam = useCallback(() => {
    navigate(Pages.TEAMS.builders.edit(team.id), { state: { fromPlayer: player.id } });
  }, [navigate, player.id, team.id]);

  const handleKickFromTeam = useCallback(() => {
    dispatch(kickTournamentUserFromTeam({ userId: player.id, teamId: team.id })).then(() => {
      toast.success('Игрок исключен из команды');
    });
  }, [dispatch, player.id, team.id]);

  return (
    <>
      <TeamCardHeaderRow>
        <div className="team-card">
          <div className="row" onClick={() => handleClickTeam}>
            {index !== undefined ? (
              <UDText type="subhead" className="team-column bold w-1/12">
                {index + 1}
              </UDText>
            ) : (
              ''
            )}

            <div className="team-column w-1/3">
              <TeamLogo className="team-logo mr-2" url={team.emblem?.externalUrl} size={52} />
              <UDText type="subhead" className="bold">
                {team.name}
              </UDText>
            </div>

            {team.createdAt ? (
              <UDText type="subhead" className="team-column w-1/6">
                {format(new Date(team.createdAt), 'dd.MM.yyyy')}
              </UDText>
            ) : (
              ''
            )}

            <div className="team-column flex w-5/12 justify-end">
              <UDButton
                className="mr-3 flex items-center"
                variant="primary"
                onClick={(e) => {
                  e.stopPropagation();
                  handleClickTeam();
                }}
              >
                <span>Редактировать</span>
              </UDButton>

              <UDButton
                className="mr-3 flex items-center"
                variant="secondary"
                onClick={(e) => {
                  e.stopPropagation();
                  open();
                }}
              >
                <span>Исключить</span>
              </UDButton>
            </div>
          </div>
        </div>

        <Modal>
          <UDText type="headline" className="text-surfaceRomanSilver30 px-10" style={{ textAlign: 'center' }}>
            Вы действительно хотите исключить игрока
          </UDText>
          <UDText type="headline" className="text-surfaceRomanSilver30 px-10" style={{ textAlign: 'center' }}>
            {player.name} {player.surname} {player.middleName ?? ''}
          </UDText>
          <UDText type="headline" className="text-surfaceRomanSilver30 mb-15 px-10" style={{ textAlign: 'center' }}>
            из {team.name}?
          </UDText>
          <div className={'flex w-full'} style={{ gap: 10 }}>
            <UDButton
              className="mb-3 flex w-1/2 items-center justify-center"
              variant="primary"
              onClick={(e) => {
                e.stopPropagation();
                close();
              }}
            >
              <span>Нет</span>
            </UDButton>
            <UDButton
              className="mb-3 flex w-1/2 items-center justify-center"
              variant="primary"
              onClick={(e) => {
                e.stopPropagation();
                handleKickFromTeam();
              }}
            >
              <span>Да</span>
            </UDButton>
          </div>
        </Modal>
      </TeamCardHeaderRow>
    </>
  );
}

export default TeamCard;
